<template>
  <div class="main">
    <main>
      <div class="tabchange">
        <span v-for="(item,index) in tabList" :key="index" :class="current==index?'active':''"
          @click="handleClick(item,index)">{{item.title}}</span>

      </div>
      <div class="main1 flex">
        <div class="left">
          <div class="tabs flex">
            <div class="list">
              <p :class="no==index?'active':''" v-for="(item,index) in data" @click="change(index)">{{item.cate_name}}
              </p>

            </div>
          </div>
        </div>
        <div class="right">
          <div v-for="(item,index) in data[no].list" :key='index' class="lianjie">
            <a :href="item.content" target="_blank"> {{item.title}}</a>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: "first",
        input: '',
        activeNo: 0,
        data: [],
        no: 0,
        no1: 0,
        current: 0,
        special: [],
        type_id: 34,
        type_list: [],
        search_data: [],
        has_detail: 1,
        tabList: [],
        contentList: []
      }
    },
    created() {
      this.$http.banner({
        cate_id: 29
      }).then(res => {
        this.contentList = res.data.list
      })
      this.$http.articleRecommendCate().then(res => [
        this.tabList = res.data.list
      ])
      this.$http.banner({
        cate_id: 25
      }).then(res => {
        this.data = res.data.list
      })

    },
    methods: {
      tabchange(item, index) {
        this.activeNo = index
      },
      handleClick(item, index) {
        this.current = index
        this.$http.articleRecommendCate({
          cate_id: item.id
        }).then(res => [
          // this.tabList = res.data.list
        ])

      },
      change(index) {
        this.no = index
        this.activeNo = 0
        this.search_data = []

      },
      goDetail(item) {
        this.$router.push('/specialtyDetail?id=' + item.major_code)
      }
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .lianjie {
    text-decoration: underline;
    font-size: 20px;
    margin-bottom: 30px;
    color: #0000EE;
  }

  .right {
    width: 800px;
    margin-left: 31px;
    text-align: left;
  }

  .title {
    width: 100%;
    text-align: left;
    text-indent: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #343434;
    border-bottom: 1px solid #EEEEEE;
    padding-bottom: 20px;
  }

  .left {
    width: 267px;

    .list {
      // height: 555px;
      background: #FFFFFF;
      border: 1px solid #EDEDED;

      p {
        width: 255px;
        height: 45px;
        line-height: 45px;
        text-align: left;
        text-indent: 14px;
      }

      .active {
        background: $color;
        color: #FFFFFF;
      }
    }

  }

  .tabs {
    text-align: left;
    margin-top: 30px;

    .zhuanye_name {
      position: relative;
    }

    .active {
      border-bottom: none !important;
      color: $color;
      height: 41px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      position: relative;
    }

    .active::after {
      content: "";
      display: block;
      width: 100%;
      height: 3px;
      background: #fff;
      position: absolute;
      left: 0;
      bottom: -2px;
    }

    span {
      display: inline-block;
      line-height: 40px;
      padding: 0 10px;
      height: 41px;
      border: 1px solid #EEEEEE;
      margin-left: -1px;
      margin-top: -1px;

    }
  }

  .tabchange {
    text-align: left;
    font-size: 20px;

    span {
      display: inline-block;
      width: 100px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      cursor: pointer;
    }

    .active {
      border-bottom: 3px solid $color;
      font-size: 24px;
    }
  }

  .content {
    width: 1280px;
    margin: 0px auto;
    overflow: hidden;
  }

  .main1 {
    align-items: baseline;
  }

  .one {
    justify-content: space-between;
    flex-wrap: nowrap;

    .info1 {
      margin-left: 68px;

      img {
        width: 20px;
        height: 20px;
        margin-top: 16px;
      }
    }

    text-align: left;
    border-bottom: 1px solid #F2F2F2;
    padding-bottom: 37px;
    margin-top: 30px;

    button {
      width: 74px;
      height: 32px;
      background: $color;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;
      // margin-left: 240px;
    }

    img {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .type {
      margin-top: 22px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;

      span {
        margin-right: 30px;
      }
    }

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 29px;
      font-weight: bold;
    }

    .address {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }

  .schoolList {
    margin: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/info/promote.vue